import { render, staticRenderFns } from "./AssignmentChip.vue?vue&type=template&id=5653a750&scoped=true&"
import script from "./AssignmentChip.vue?vue&type=script&lang=ts&"
export * from "./AssignmentChip.vue?vue&type=script&lang=ts&"
import style0 from "./AssignmentChip.vue?vue&type=style&index=0&id=5653a750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5653a750",
  null
  
)

export default component.exports